import api from '../api';

export const fetchPlansDictionary = async () => {
  const strategies = await api.get('/mng/strategies');
  const agreements = await api.get('/mng/agreements');
  const bcCodes = await api.get('/mng/bcCodes');
  const fundings = await api.get('/mng/funding');
  const costAgrs = await api.get('/mng/cost/agrs');
  const costKvrs = await api.get('/mng/cost/kvrs');

  return {
    strategies,
    agreements,
    bcCodes,
    fundings,
    costAgrs,
    costKvrs,
  };
};

export const mapIdsToLabels = (plansDictionary, idsEntry) => {
  const result = {
    strategy: undefined,
    agreement: undefined,
    agreementNum: undefined,
    bcCode: undefined,
    bcCodeNum: undefined,
    funding: undefined,
  };

  if (idsEntry.strategyId) {
    const foundStrategy = plansDictionary.strategies.find((s) => s.id === idsEntry.strategyId);
    if (foundStrategy) result.strategy = foundStrategy.name;
  }

  const foundAgreement = plansDictionary.agreements.find((a) => a.id === idsEntry.agreementId);
  if (foundAgreement) {
    result.agreement = foundAgreement.name;
    result.agreementNum = foundAgreement.num;
  }

  const foundBcCode = plansDictionary.bcCodes.find((bc) => bc.id === idsEntry.bcCodeId);
  if (foundBcCode) {
    result.bcCode = foundBcCode.name;
    result.bcCodeNum = foundBcCode.fullCode;
  }

  const foundFunding = plansDictionary.fundings.find((f) => f.id === idsEntry.fundingId);
  if (foundFunding) result.funding = foundFunding.name;

  if (idsEntry.costAgrId) {
    const foundCostAgr = plansDictionary.costAgrs.find((f) => f.id === idsEntry.costAgrId);
    if (foundCostAgr) {
      result.costAgrNum = foundCostAgr.num;
      result.costAgrName = foundCostAgr.name;
    }
  }

  if (idsEntry.costKvrId) {
    const foundCostKvr = plansDictionary.costKvrs.find((f) => f.id === idsEntry.costKvrId);
    if (foundCostKvr) {
      result.costKvrNum = foundCostKvr.num;
      result.costKvrName = foundCostKvr.name;
    }
  }

  return result;
};
